import { render, staticRenderFns } from "./fileview.vue?vue&type=template&id=256c1b5a&"
import script from "./fileview.vue?vue&type=script&lang=js&"
export * from "./fileview.vue?vue&type=script&lang=js&"
import style0 from "./fileview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports